angular.module('core')
  .factory('taggable', [function() {
    // Returns a function for adding tag related functionality to an object.
    // Assumes tags are stored in a tags property on the object.

    var Taggable = function () {
        var tagIndex;

        function ensureIndex (_this) {
            if (!tagIndex) {
                tagIndex = _.indexBy(_this.tags);
             }
        }

        this.hasTag = function (tag) {
            ensureIndex(this);

            return !!tagIndex[tag];
        };
    };

    function taggable (obj) {
        if (typeof obj === 'object' && obj !== null) {
            angular.extend(obj, new Taggable());
        }

        return obj;
    }

    return taggable;
  }]);
